import { Injectable } from "@angular/core";
import { StockTestService } from "./stock-test.service";
import { AppropriatenessModalComponent } from "../components/stocks/appropriateness-modal/appropriateness-modal.component";
import { ModalService } from "@core-services/modal.service";

@Injectable({
	providedIn: "root"
})
export class StockTestHelperService {
	public constructor(
		private stockTestService: StockTestService,
		private modalService: ModalService
	) {}

	// Stocks Test start (callback is for success)
	public startTest(callback: Function = null, closeAll: boolean = false): void {
		if (this.stockTestService.getIsOpen()) {
			return;
		}
		this.stockTestService.setTestOpen(true);
		this.modalService
			.create(AppropriatenessModalComponent, {
				callback: callback,
				closeAllOnDismiss: closeAll
			})
			.present();
	}
}
